<template>
  <div aria-live="polite" aria-atomic="true" class="position-relative">
    <div class="toast-container end-0 position-fixed p-3"
      style="min-width: 180px; z-index: 1060; bottom: 80px">
      <div
        v-for="msg in toastsMessages" :key="msg.id" class="toast show"
        role="alert" aria-live="assertive" aria-atomic="true">
        <div class="toast-header" :class="msg.statusBg">
          <strong class="mr-auto" :class="msg.statusColor">
            ${ msg.title }
          </strong>
        </div>
        <div class="toast-body">
          ${ msg.message }
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 全域 Toast 提示容器 (Toasts.vue)
 *
 * 訂閱 `useToast` 的 `toastsMessages`，將提示訊息以 Bootstrap toast 堆疊顯示於畫面右下角。
 */
import { watch } from 'vue';
import { useToast } from '../composables/useToast';

export default {
  name: 'Toast',
  setup() {
    const { toastsMessages } = useToast();
    watch(toastsMessages, () => {}, { deep: true });
    return {
      toastsMessages,
    };
  },
};
</script>

<spec lang="md">
# 全域 Toast 提示 (Toasts.vue)

## 元件概述
- **用途**：訂閱 `useToast` 的訊息佇列，將提示訊息以 Bootstrap toast 形式堆疊顯示。

## Props
無

## Emits
無

## Slots
無

## 功能行為
- 透過 `useToast()` 取得 `toastsMessages` 並以 `v-for` 渲染
- 以 `watch(toastsMessages, ..., { deep: true })` 深度監聽訊息陣列變化
- 每則 toast 依 `msg.statusBg` / `msg.statusColor` 套用樣式，顯示 `title` 與 `message`

## 測試行為
- `toastsMessages` 有訊息時，應為每則訊息渲染一個 `.toast`
- 每則 toast 應顯示 `msg.title` 與 `msg.message`
- 應依 `msg.statusBg` / `msg.statusColor` 套用樣式
- `toastsMessages` 為空時，不應渲染任何 toast

## UI 規格
- 容器 `.toast-container` 固定於右下角（`position-fixed`、bottom 80px、z-index 1060）
- 每則使用 Bootstrap `.toast.show`，含 `.toast-header` 與 `.toast-body`
- 具無障礙屬性 `aria-live`、`aria-atomic`、`role="alert"`
</spec>
